// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomInsuranceBillingCenter from './view'

export default function DataVaxiomInsuranceBillingCenterFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomInsuranceBillingCenter">
      <DataVaxiomInsuranceBillingCenter {...props}>
        {children}
      </DataVaxiomInsuranceBillingCenter>
    </Flow>
  )
}
